// local
// const BASE_URL = "http://192.168.6.19:5001/node-api/";
// const DEFAULT_KEY = '742f49f9-8844-4138-b179-789a306c246a'
// const PAYPAL_CLIENT_ID = "ATzqhlwkcobW4xO8_3ymbUL_U10zQpn6ZBoCEme9oQjT660L5xV6350YzFVASw0X0P_ym2MdACjD-Ju8"

// demo
// const BASE_URL = "https://admin.capua.iossmlm.com/node-api/"
// const DEFAULT_KEY = "742f49f9-8844-4138-b179-789a306c246a"
// const PAYPAL_CLIENT_ID = "ATzqhlwkcobW4xO8_3ymbUL_U10zQpn6ZBoCEme9oQjT660L5xV6350YzFVASw0X0P_ym2MdACjD-Ju8"

// live
const BASE_URL = "https://admin.fmobile.us/node-api/"
const DEFAULT_KEY = "742f49f9-8844-4138-b179-789a306c246a"
const PAYPAL_CLIENT_ID = "AVlsFF6CSd_-TtznlJ2W55tmkXkwZyTAugJXxu1xF2IQvZfhkn4dpWVtENcUHNmZ_XomOFum35i-AKRz"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }